import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faCreditCardBlank,
  faExclamationCircle,
  faCheck,
  faCalendar,
  faTimes,
  faLongArrowDown,
  faLongArrowUp,
  faAngleDoubleLeft,
  faAngleDoubleRight,
  faAngleLeft,
  faAngleRight,
  faChevronLeft,
  faChevronDown,
  faSearch,
  faLayerGroup,
  faMinus,
  faPlus,
  faFilePdf,
  faUser,
  faUserCircle,
  faCog,
  faUserFriends,
  faBriefcase,
  faMugHot,
  faDollarSign,
  faFile,
  faExclamationTriangle,
  faInfoCircle,
  faReceipt,
  faCheckCircle,
  faShareAlt,
  faTimesCircle
} from "@fortawesome/pro-light-svg-icons";

(function initFortAwesome() {
  library.add(
    faCreditCardBlank,
    faExclamationCircle,
    faCheck,
    faCalendar,
    faTimes,
    faLongArrowDown,
    faLongArrowUp,
    faAngleDoubleLeft,
    faAngleDoubleRight,
    faAngleLeft,
    faAngleRight,
    faChevronLeft,
    faChevronDown,
    faSearch,
    faLayerGroup,
    faMinus,
    faPlus,
    faFilePdf,
    faUser,
    faUserCircle,
    faCog,
    faUserFriends,
    faBriefcase,
    faMugHot,
    faDollarSign,
    faFile,
    faInfoCircle,
    faExclamationTriangle,
    faReceipt,
    faCheckCircle,
    faShareAlt,
    faTimesCircle
  );
})();
